module.exports = __webpack_public_path__ + "img/katarina_outside_19.0728e5f8.jpg";